export const columns = [
  {
    title: "Colas",
    dataIndex: "queue_name",
    width: 300,
    ellipsis: true,
    slots: { customRender: "queue_name" },
  },
  {
    title: "Total de chats",
    dataIndex: "total_interactions",
  },
  {
    title: "N° NS",
    dataIndex: "sum_service_level",
    width: 140,
    tooltip: {
      title: "Número de nivel de servicio.",
      description:
        "Indica cuántos tickets atiende el agente dentro del NS configurado en la cola.",
    },
  },
  {
    title: "NS %",
    dataIndex: "mean_service_level",
    width: 140,
    slots: { customRender: "mean_service_level" },
    tooltip: {
      title: "Porcentaje del nivel de servicio.",
      description:
        "Indica el porcentaje de tickets que el agente atendió dentro del NS configurado en la cola.",
    },
  },
  {
    title: "TP espera",
    dataIndex: "mean_time_waiting",
    slots: { customRender: "time" },
    tooltip: {
      title: "Tiempo promedio de espera.",
      description:
        "Es el promedio del tiempo que un ticket permanece en la cola hasta ser asignado a un agente.",
    },
  },
  {
    title: "TP primera respuesta",
    dataIndex: "mean_time_first_answer",
    slots: { customRender: "time" },
    tooltip: {
      title: "Tiempo promedio de la primera respuesta.",
      description:
        "Es el promedio del tiempo por interacción que le toma al agente en enviar su primera respuesta desde que el ticket le es asignado.",
    },
  },
  {
    title: "TP resolución",
    dataIndex: "mean_time_resolution",
    slots: { customRender: "time" },
    tooltip: {
      title: "Tiempo promedio de resolución.",
      description:
        "Es el promedio del tiempo que le toma a un agente resolver un ticket, contando únicamente los tickets resueltos por el agente.",
    },
  },
  {
    title: "N° asignados",
    dataIndex: "total_assigned",
    tooltip: {
      title: "Número de usuarios asignados.",
      description: "Indica el total de usuarios que están asignados a la cola.",
    },
  },
  {
    title: "Acciones",
    fixed: "right",
    width: 120,
    slots: { customRender: "actions" },
  },
];

